import React from "react";
import {Link, Typography} from "@mui/material";


export default function Copyright() {
    return (
        <Typography variant="body2" color="inherit" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.litislab.fr/" target="_blank" rel="noopener">
                litis
            </Link>
            {' 2009-'}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}
